import React from "react";
import Contact from "../Components/contact/Contact";
import TopBar from "../Components/common/TopBar";
import Spacer2 from "../Components/common/Spacer2";
import useSEO from "../seo/useSEO";

function ContactPage() {
  useSEO({
    title: "İletişim | Aypin Otomat",
    description:
      "Aypin Otomat ile iletişime geçin. Çalı Mahallesi Ömer Biltekin Caddesi No: 4/A Nilüfer, Bursa. Telefon: +90 532 162 1647.",
    path: "/iletisim",

    breadcrumbs: [
      {
        name: "Ana Sayfa",
        path: "/",
      },
      {
        name: "İletişim",
        path: "/iletisim",
      },
    ],
  });

  return (
    <>
      <TopBar />
      <Spacer2 />

      <Contact isPage={true} />
    </>
  );
}

export default ContactPage;